import { render, staticRenderFns } from "./ApprovalRequest.vue?vue&type=template&id=6b637060&scoped=true&"
import script from "./ApprovalRequest.vue?vue&type=script&lang=js&"
export * from "./ApprovalRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b637060",
  null
  
)

export default component.exports